import {forwardRef} from "react";

const PageInbox = forwardRef((props, ref)=>{
    return(
        <div style={{height: '100vh'}}>

        </div>
    )
})
export default PageInbox;